import React from "react";
import styled from "styled-components";
// Components
import {ProjectBox, AppProjectBox} from "../Elements/ProjectBox";
import FullButton from "../Buttons/FullButton";
// Assets
import ProjectImg1 from "../../assets/img/projects/1.png";
import ProjectImg2 from "../../assets/img/projects/2.png";
import ProjectImg3 from "../../assets/img/projects/3.png";
import ProjectImg4 from "../../assets/img/projects/4.png";
import ProjectImg5 from "../../assets/img/projects/5.png";
import ProjectImg6 from "../../assets/img/projects/6.png";

import DStreakPoster from "../../assets/img/dstreak.png";
import ScorpionYachtPoster from "../../assets/img/scorpionyacht.png";
import SupervetPoster from "../../assets/img/supervet.png";
import FloPilatesPoster from "../../assets/img/flopilates.png";
import SesconPoster from "../../assets/img/sescon.png";
import FragrancePoster from "../../assets/img/fragrance.png";
import PulsePoster from "../../assets/img/pulse.png";
import HeloSeerPoster from "../../assets/img/seer.png";
import ToycovePoster from "../../assets/img/toycove.png";
import BitnoaPoster from "../../assets/img/bitnoa.png";

export default function Projects() {
  const DStreakUrl= 'https://play.google.com/store/apps/details?id=com.drivestreak&pcampaignid=web_share';
  const ScorpionYactUrl= 'https://play.google.com/store/apps/details?id=com.scorpionyacht&pcampaignid=web_share';
  const SupervetUrl= 'https://play.google.com/store/apps/details?id=com.myall&pcampaignid=web_share';
    const FloPilates ='https://play.google.com/store/apps/details?id=com.flopilates&pcampaignid=web_share';
    const FloPilatesIosUrl='https://apps.apple.com/us/app/flo-pilates/id6741110734';
    const BitnoaUrl= 'https://bitnoa.com';
const SesconUrl = 'https://thesescon.com';
const FragranceUrl = 'https://globalfragranceimports.com';
const PulseMarketUrl = 'https://pulse-marketing.vercel.app';
  const HelLoSeerUrl= 'https://www.helloseer.com';
  const ToycoveUrl= 'https://toycov-preview.vercel.app';
  const ScorpionYachtIosUrl= 'https://apps.apple.com/ca/app/scorpionyacht/id1659795823';
  return (
    <Wrapper id="projects">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
           <h1 className="font40 extraBold">Our Portfolio</h1>
<p className="font13">
  Explore our diverse range of successful projects that showcase our expertise in 
  <br />
  software development, from innovative web applications to robust mobile solutions.
</p>
          </HeaderInfo>
          
             <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
           <AppProjectBox
            img={DStreakPoster}
                title="Drive Streak"
                text="Our NFT-powered app rewards users for every mile they travel using Google Maps.
Earn tokens as you move, then use them to purchase exclusive NFTs.
Trade or sell your NFTs to turn exploration into real digital value."
androidUrl={DStreakUrl}
  // iosUrl="app-store-link"
/>
    
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
   
              <AppProjectBox
                img={ScorpionYachtPoster}
                title="Scorpion Yacht Club"
                text="Scorpion Yacht is a luxury yacht booking app based in Miami.
It allows users to explore, book, and manage exclusive yacht experiences with ease.
Enjoy premium services and unforgettable moments on the water."
                androidUrl={ScorpionYactUrl}
   iosUrl={ScorpionYachtIosUrl}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <AppProjectBox
                img={FloPilatesPoster}
                title="Flo Pilates"
                text="Flo Pilates is a health and wellness app focused on fitness and nutrition.
It offers personalized diet plans and guided video tutorials for effective workouts.
Stay fit, eat smart, and achieve your wellness goals anytime, anywhere."
                 androidUrl={FloPilates}
   iosUrl={FloPilatesIosUrl}
              />
             
            </div>
          </div>
       
          <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <AppProjectBox
                img={SupervetPoster}
                title="Supervet"
                text="Dive into the Supervet AI Game universe through immersive comic stories. Each panel unlocks exclusive NFTs that enhance your gameplay. Collect, trade, and own pieces of the Supervet world."
               androidUrl={SupervetUrl}
  // iosUrl="app-store-link"
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={SesconPoster}
                title="The Sescon"
                text="We deliver exceptional construction services with a focus on quality and precision.
Our experienced team brings your vision to life with skill and dedication.
From concept to completion, we create durable, functional, and beautiful structures."
               action={() => window.open(SesconUrl,'_blank')}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={FragrancePoster}
                title="Global Fragrance"
                text="We craft a luxurious fragrance shopping experience designed for perfume lovers.
Discover premium scents from top brands and exclusive collections in one place.
Find your perfect fragrance and let every moment smell unforgettable.
"
             action={() => window.open(FragranceUrl,'_blank')}
              />
            </div>
          </div>

            <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={PulsePoster}
                title="Pulse Marketing"
                text="Pulse Marketing is a results-driven agency helping businesses grow through strategic, data-driven marketing.
We craft impactful campaigns that boost visibility, engagement, and sales. Our goal is to turn your brand vision into measurable success.
"
                action={() => window.open(PulseMarketUrl,'_blank')}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={HeloSeerPoster}
                title="Seer"
                text="Seer is a luxury sales platform that empowers associates to create personalized, high-impact content.
It helps brands connect with clients through engaging, click-worthy experiences.
With Seer, luxury sales become more personal, effective, and rewarding.
"
                action={() => window.open(HelLoSeerUrl,'_blank')}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <ProjectBox
                img={BitnoaPoster}
                title="Bitnoa"
                text="Where premium leather meets timeless craftsmanship. Discover jackets and accessories built to last a lifetime. Experience the perfect blend of durability, style, and sophistication."
                 action={() => window.open(BitnoaUrl,'_blank')}
              />
            </div>
          </div>

          <div className="row flexCenter">
            {/* <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton title="Load More" action={() => alert("clicked")} />
            </div> */}
          </div>
        </div>
      </div>


      <div style={{height:30}}></div>
      {/* <div className="lightBg">
        <div className="container">
          <Advertising className="flexSpaceCenter">
            <AddLeft>
              <AddLeftInner>
                <ImgWrapper className="flexCenter">
                  <img className="radius8" src={AddImage2} alt="add" />
                </ImgWrapper>
              </AddLeftInner>
            </AddLeft>
            <AddRight>
              <h4 className="font15 semiBold">A few words about company</h4>
              <h2 className="font40 extraBold">A Study of Creativity</h2>
              <p className="font12">
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed
                diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              </p>
              <ButtonsRow className="flexNullCenter" style={{ margin: "30px 0" }}>
                <div style={{ width: "190px" }}>
                  <FullButton title="Get Started" action={() => alert("clicked")} />
                </div>
                <div style={{ width: "190px", marginLeft: "15px" }}>
                  <FullButton title="Contact Us" action={() => alert("clicked")} border />
                </div>
              </ButtonsRow>
            </AddRight>
          </Advertising>
        </div>
      </div> */}
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
`;
const HeaderInfo = styled.div`
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const Advertising = styled.div`
  padding: 100px 0;
  margin: 100px 0;
  position: relative;
  @media (max-width: 1160px) {
    padding: 60px 0 40px 0;
  }
  @media (max-width: 860px) {
    flex-direction: column;
    padding: 0 0 30px 0;
    margin: 80px 0 0px 0;
  }
`;
const ButtonsRow = styled.div`
  @media (max-width: 860px) {
    justify-content: space-between;
  }
`;
const AddLeft = styled.div`
  position: relative;
  width: 50%;
  p {
    max-width: 475px;
  }
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
    text-align: center;
    h2 {
      line-height: 3rem;
      margin: 15px 0;
    }
    p {
      margin: 0 auto;
    }
  }
`;
const AddRight = styled.div`
  width: 50%;
  @media (max-width: 860px) {
    width: 80%;
    order: 2;
  }
`;
const AddLeftInner = styled.div`
  width: 100%;
  position: absolute;
  top: -300px;
  left: 0;
  @media (max-width: 1190px) {
    top: -250px;
  }
  @media (max-width: 920px) {
    top: -200px;
  }
  @media (max-width: 860px) {
    order: 1;
    position: relative;
    top: -60px;
    left: 0;
  }
`;
const ImgWrapper = styled.div`
  width: 100%;
  padding: 0 15%;
  img {
    width: 100%;
    height: auto;
  }
  @media (max-width: 400px) {
    padding: 0;
  }
`;
